export default { getBase, postBase };

function getBase () {
  return {
    method: 'GET',
    mode: 'cors',
    credentials: 'include',
    headers: {
      Accept:
        'application/x-www-form-urlencoded;multipart/form-data;application/json;text/plain;text/html;text/xml',
      'Content-Type':
        'application/x-www-form-urlencoded;multipart/form-data;application/json;text/plain;text/html;text/xml',
    },
  };
}

function postBase (body) {
  return {
    method: 'POST',
    mode: 'cors',
    credentials: 'include',
    headers: {
      Accept:
        'application/x-www-form-urlencoded;multipart/form-data;application/json;text/plain;text/html;text/xml',
      'Content-Type':
        'application/x-www-form-urlencoded;multipart/form-data;application/json;text/plain;text/html;text/xml',
    },
    body: body,
  };
}



// WEBPACK FOOTER //
// ./src/remoting/Request.js